import Repository from '../axios'

const resource = "/landlord/currencies"

export default {
  getCurrencyList(){
    return Repository.get(`${resource}`)
  }
}
